import React, { useEffect, useRef } from "react";
import styles from "../styles/UnitModifier.module.css";

interface ConfirmModalProps {
    isOpen: boolean;
    title?: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    title = "Confirm Action",
    message,
    onConfirm,
    onCancel,
}) => {
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onCancel();
            if (e.key === "Enter") onConfirm();
        };
        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onCancel, onConfirm]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === overlayRef.current) {
            onCancel();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            ref={overlayRef}
            className={styles.modal}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={handleOverlayClick}
        >
            <div className={styles.modalContent} style={{ minWidth: "340px", padding: "2rem 2.5rem" }}>
                <h2 className={styles.modalTitle} style={{ marginBottom: "1.5rem", textAlign: "center" }}>{title}</h2>
                <div className={styles.modalLabel} style={{ marginBottom: "2rem", textAlign: "center" }}>
                    {message}
                </div>
                <div className={styles.modalButtons} style={{ display: "flex", gap: "1rem", justifyContent: "center", marginTop: "2rem" }}>
                    <button
                        className={styles.addUnitBtn}
                        style={{ backgroundColor: "#43A047", color: "white", minWidth: "100px" }}
                        onClick={onConfirm}
                    >
                        Confirm
                    </button>
                    <button
                        className={styles.cancelBtn}
                        style={{ minWidth: "100px" }}
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
